export default __webpack_public_path__ + "static/safari-b8bf72ee61f58c60edb2ffa27b172d07.svg";